import { FC, useEffect, useState } from 'react';
import { Grid as KendoGrid, GridColumn } from '@progress/kendo-react-grid';
import useCustomer from 'src/hooks/useCustomer';
import { State as ODataState } from '@progress/kendo-data-query';
import NumberCell from 'src/components/grid/NumberCell';
import ItemApi from 'src/api/ItemApi';
import UomCell from 'src/components/grid/UomCell';
import { ItemHistory } from 'src/types/itemHistory';
import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

declare interface IProps {
  itemNumber: string;
  itemName: string;
  visible: boolean;
}

const ItemDetailHistory: FC<React.PropsWithChildren<IProps>> = ({ itemNumber, itemName, visible }) => {
  const { customer } = useCustomer();
  const [onOrderItems, setOnOrderItems] = useState<ItemHistory[]>();
  const [gridDataState, setGridDataState] = useState<ODataState>({});

  useEffect(() => {
    if (itemNumber) {
      ItemApi.getItemHistory(itemNumber, itemName, customer.number).then((data) => {
        data.forEach((d) => (d.invoiceDate = new Date(d.invoiceDate)));
        data.forEach((d) => (d.promisedDate = new Date(d.promisedDate)));
        setOnOrderItems(data);
      });
    }
  }, [gridDataState, itemNumber]);

  const handleGridDataStateChange = (e: any) => {
    setGridDataState(e.dataState);
  };

  const invoiceCell = (cellProps) => {
    return (
      <td>
        <Link
          target="_blank"
          style={{ color: '#0000FF' }}
          component={RouterLink}
          to={`/${cellProps.dataItem.customerNumber}/OrderDetail/${cellProps.dataItem.orderNumber}-${cellProps.dataItem.orderSuffix}`}
        >
          <u>{cellProps.dataItem.fullOrderNumber}</u>
        </Link>
      </td>
    );
  };

  const qtyCell = (cellProps) => <UomCell {...cellProps} uomField="unitOfMeasure" />;

  return (
    <div role="tabpanel" hidden={!visible} id="on-order" aria-labelledby="on-order-tab">
      <KendoGrid data={onOrderItems} scrollable="scrollable" dataItemKey="warehouse" onDataStateChange={handleGridDataStateChange} {...gridDataState}>
        <GridColumn field="fullOrderNumber" cells={{ data: invoiceCell }} title="Invoice #" width={100} />
        <GridColumn field="customerPO" title="Cust PO #" width={280} />
        <GridColumn field="invoiceDate" title="Invoice Date" format="{0:MM/dd/yyyy}" width={100} />
        <GridColumn field="promisedDate" title="Promised Date" format="{0:MM/dd/yyyy}" width={100} />
        <GridColumn field="quantity" format="0" cells={{ data: qtyCell }} title="Qty" width={100} />
        <GridColumn field="price" format="c" cells={{ data: NumberCell }} title="Price" width={100} />
        <GridColumn field="" title="" editable={false} />
      </KendoGrid>
    </div>
  );
};

export default ItemDetailHistory;
